import { OutboundLink } from 'react-ga'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { Color } from '../color'
import { shadowCtaCss } from './shared'

const baseLinkCss = css`
  display: flex;
  justify-content: center;
  align-items: center;

  white-space: nowrap;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  color: ${Color.white};
`

const roundLinkCss = css`
  height: 40px;
  padding: 0 20px;
  border-radius: 20px;

  cursor: pointer;
  font-size: 14px;
`

export const NewTabLink = styled(({ to, ...props }) => (
  <OutboundLink {...props} to={`${process.env.PUBLIC_URL}${to}`} />
)).attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  text-decoration: none;
  color: inherit;
`

const BaseLink = styled(NewTabLink)`
  ${baseLinkCss}
`

export const ShadowLink = styled(BaseLink)`
  ${shadowCtaCss}
`

export const RoundLink = styled(BaseLink)`
  ${roundLinkCss}
`

export const BlueLink = styled(BaseLink)`
  height: 60px;
  border-radius: 30px;
  padding: 0 25px;
  font-size: 16px;
  background-color: ${Color.purple_600};
  &:hover {
    opacity: 0.8;
  }
`

export const InternalLink = styled(Link)`
  text-decoration: none;
  color: inherit;
`

const InternalBaseLink = styled(InternalLink)`
  ${baseLinkCss}
`

export const InternalRoundLink = styled(InternalBaseLink)`
  ${roundLinkCss}
`

export const SameTabExternalLink = styled(OutboundLink)`
  text-decoration: none;
  color: inherit;
`
